// Switch between the paper (light) edition, the night (dark) edition and
// following the reader's device.
//
// The site-wide default comes from Ghost admin and is written to
// <html data-theme-default>. A reader's choice overrides it and is kept in
// localStorage; "system" is one of those choices, so a reader who has
// picked an edition can always hand control back to their device. Landing
// back on the site's own setting clears the stored value, so a later change
// in admin is picked up again.
//
// default.hbs applies the stored choice inline before first paint, so there
// is no flash.

const STORAGE_KEY = "np-theme";
const MODES = ["light", "dark", "system"];

const LABELS = {
    light: "Colour scheme: light. Switch to dark.",
    dark: "Colour scheme: dark. Switch to following your device.",
    system: "Colour scheme: following your device. Switch to light."
};

export default function themeToggle() {
    const button = document.querySelector("[data-theme-toggle]");
    if (!button) return;

    const root = document.documentElement;
    const fallback = root.getAttribute("data-theme-default");
    const siteDefault = MODES.includes(fallback) ? fallback : "system";

    const current = () => {
        const mode = root.getAttribute("data-theme");
        return MODES.includes(mode) ? mode : siteDefault;
    };

    const show = (mode) => {
        root.setAttribute("data-theme", mode);
        button.setAttribute("aria-label", LABELS[mode]);
        button.setAttribute("title", LABELS[mode]);
    };

    show(current());

    button.addEventListener("click", () => {
        const next = MODES[(MODES.indexOf(current()) + 1) % MODES.length];
        show(next);
        try {
            if (next === siteDefault) {
                localStorage.removeItem(STORAGE_KEY);
            } else {
                localStorage.setItem(STORAGE_KEY, next);
            }
        } catch (e) {
            // Storage unavailable (private mode, blocked). The switch still
            // works for this page.
        }
    });
}
